<template>
  <footer id="footer">
    <div id="copyrights" class="bgcolor">
      <div class="container clearfix">
        <div class="row justify-content-between align-items-center">
          <div class="col-12 text-light text-center">
            &copy; 2019 Tüm Hakları Saklıdır.
            <br />Birlikte Güçlüyüz Platformu
            <br />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style></style>
